module.exports = "\r\n<div class=\"search-popup-container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <lfwms-search-filter [searchService]=\"lookupService\">\r\n      </lfwms-search-filter>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/cycle-count/stock-take-parameters/cycle-count-home/cycle-count-details/cc-search-popup/cc-search-popup.component.html
// module id = ../../../../../src/app/features/inventory/cycle-count/stock-take-parameters/cycle-count-home/cycle-count-details/cc-search-popup/cc-search-popup.component.html
// module chunks = main